import Image from 'next/image';
import { Dispatch, SetStateAction } from 'react';
import { useIntl } from 'react-intl';

import { useTrackEventAmplitude } from '../../../../../../core/Tracking/Amplitude/Amplitude';
import { IconArrowRight } from '../../../../../../design-system/components/icons/ArrowRight';
import { Typography } from '../../../../../../design-system/components/typography/Typography';
import { HubDestinationMenu } from '../../../../../../resources/hubDestinationMenu/domain/types/hubDestinationMenu';
import { Container } from '../../../../Container/Container';
import { imageLoaderForPath } from '../../../../Image/URL/ImageURL';
import { PrimaryNavValue } from '../../../types';
import { MobileSubNav } from '../MobileSubNav/MobileSubNav';
import { MobileView } from '../MobileView';

import { HubDestinationContent } from './HubDestinationContent/HubDestinationContent';
import style from './HubDestinationMobileView.module.css';

export function HubDestinationMobileView({
    hubDestinationMenu,
    setNavValue,
}: {
    hubDestinationMenu: HubDestinationMenu;
    setNavValue: Dispatch<SetStateAction<PrimaryNavValue>>;
}) {
    const { trackEvent } = useTrackEventAmplitude();
    const { formatMessage } = useIntl();

    return (
        <>
            <MobileSubNav showPreviousButton={false} setNavValue={setNavValue} />
            <MobileView
                title={hubDestinationMenu.destination.name}
                beforeTitleSlot={
                    <button
                        className={style.allDestinationsButton}
                        onClick={() => {
                            setNavValue('DESTINATIONS');
                            trackEvent((ampli, defaultProperties) => {
                                ampli.primaryNavAllDestinationsClicked({
                                    ...defaultProperties,
                                    block: 'primary_nav',
                                });
                            });
                        }}
                    >
                        <div className={style.buttonContent}>
                            <Image
                                className={style.image}
                                src="/navbar/all-destinations-w-138.png"
                                alt=""
                                width={46}
                                height={40}
                                loader={imageLoaderForPath}
                            />
                            <Typography scale="primary-xs-bold">
                                {formatMessage({
                                    id: 'global.header.globalNav.destinations.hubDestination.button.seeAllDestinations',
                                })}
                            </Typography>
                        </div>
                        <div className={style.icon}>
                            <IconArrowRight />
                        </div>
                    </button>
                }
            >
                <Container>
                    <HubDestinationContent hubDestinationMenu={hubDestinationMenu} />
                </Container>
            </MobileView>
        </>
    );
}
